import { defineComponent as w, ref as b, watch as r, onBeforeMount as h, onUnmounted as v, openBlock as l, createElementBlock as C, normalizeClass as i, withModifiers as u, renderSlot as c, createVNode as y, withCtx as p, createElementVNode as g, createBlock as k, unref as $, createCommentVNode as B, resolveDynamicComponent as D } from "vue";
import { _ as E } from "./BaseButton.vue_vue_type_script_setup_true_lang.dlLTK59i.js";
import { d as L } from "./ArrowIcon.GDkXwpPs.js";
import "./DownloadIcon.DHCHRETy.js";
const S = ["innerHTML"], H = /* @__PURE__ */ w({
  inheritAttrs: !1,
  __name: "BaseDropDown",
  props: {
    id: { default: "" },
    dropdownClasses: { default: "" },
    containerDropdownClasses: { default: "" },
    iconName: { default: "" },
    iconClasses: { default: "" },
    btnClasses: { default: "" },
    withArrowIcon: { type: Boolean, default: !1 },
    btnLabel: { default: "" },
    labelClasses: { default: "" },
    direction: { default: "down" },
    arrowWidth: { default: 12 },
    isAbsolute: { type: Boolean, default: !0 },
    openDropdown: { type: Boolean, default: !1 },
    closeWhenClickedOutside: { type: Boolean, default: !0 },
    dropdownElement: { default: "div" },
    keepState: { default: "" }
  },
  emits: ["click", "update:dropdownState"],
  setup(f, { emit: m }) {
    const o = f, s = m, t = b(!1);
    r(
      () => o.openDropdown,
      (e) => {
        t.value = e;
      },
      {
        immediate: !0
      }
    ), r(t, (e) => {
      s("update:dropdownState", e);
    });
    const d = () => {
      t.value = !1;
    }, n = () => {
      o.keepState === "closed" && !t.value || o.keepState === "opened" && t.value || (t.value = !t.value);
    };
    return h(() => {
      o.closeWhenClickedOutside && document && document.body.addEventListener("click", d);
    }), v(() => {
      o.closeWhenClickedOutside && document && document.body.removeEventListener("click", d);
    }), (e, a) => (l(), C("div", {
      class: i(["uikit-relative uikit-block", e.$attrs.class]),
      onClick: a[1] || (a[1] = u((W) => {
        s("click"), n();
      }, ["stop"]))
    }, [
      c(e.$slots, "btn_slot", {
        toggleDropdown: n,
        isOpen: t.value
      }, () => [
        y(E, {
          id: e.id,
          type: "button",
          "data-cy": e.$attrs["data-cy"],
          class: i([
            "!uikit-flex uikit-w-full uikit-items-center uikit-truncate",
            e.btnClasses
          ]),
          "aria-expanded": t.value,
          "btn-class": "uikit-btn-single-selection",
          "icon-class": e.iconClasses,
          "icon-name": e.iconName
        }, {
          default: p(() => [
            g("span", {
              class: i(["uikit-mr-5px", e.labelClasses]),
              innerHTML: e.btnLabel
            }, null, 10, S),
            e.withArrowIcon ? (l(), k($(L), {
              key: 0,
              class: i(["uikit-shrink-0 uikit-transition-transform motion-reduce:uikit-transition-none", t.value ? "uikit-rotate-180" : ""]),
              width: e.arrowWidth,
              height: e.arrowWidth,
              "stroke-color": e.$attrs["arrow-stroke-color"]
            }, null, 8, ["class", "width", "height", "stroke-color"])) : B("", !0)
          ]),
          _: 1
        }, 8, ["id", "data-cy", "class", "aria-expanded", "icon-class", "icon-name"])
      ]),
      (l(), k(D(e.dropdownElement), {
        id: "dropdown_" + e.id,
        ref: "dropdown",
        "data-cy": e.$attrs["data-cy"] && `${e.$attrs["data-cy"]}_dropdown`,
        class: i(["uikit-max-h-[220px] uikit-w-full uikit-min-w-[90px] uikit-flex-col uikit-overflow-y-auto uikit-border uikit-border-solid uikit-border-w-lavender uikit-bg-white uikit-pl-0 uikit-opacity-100 uikit-shadow uikit-no-scrollbar", [
          e.dropdownClasses,
          t.value ? "uikit-flex" : "uikit-hidden",
          { "uikit-bottom-[55px] uikit-rounded-xs": e.direction === "up" },
          { "uikit-rounded-b uikit-border-t-0": e.direction === "down" },
          { "uikit-absolute": e.isAbsolute }
        ]]),
        onClick: a[0] || (a[0] = u(() => {
        }, ["stop"]))
      }, {
        default: p(() => [
          c(e.$slots, "default", {
            isOpen: t.value,
            toggleDropdown: n
          })
        ]),
        _: 3
      }, 8, ["id", "data-cy", "class"]))
    ], 2));
  }
});
export {
  H as _
};
